<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="mb-3">
        <vs-input :label="$t('name')" :placeholder="$t('name')" v-model="projectFormData.name" class="w-full"/>
        <validation-error :model-error="projectFormErrors.name"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('progress_status')"></label>
<!--        <v-select :options="progressStatusOptions" :reduce="label => label.value" :placeholder="$t('progress_status')" v-model="projectFormData.progress_status_id" class="md:mb-0" />-->
        <select v-model="projectFormData.progress_status_id" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('progress_status') }}</option>
          <option v-for="(option, key) in progressStatusOptions" :key="'progress_status_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="projectFormErrors.progress_status_id"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('assigned_to')"></label>
        <v-select :options="userOptions" multiple :reduce="label => label.value" :placeholder="$t('assigned_to')" v-model="projectFormData.assigned_to" class="md:mb-0 hide-selected-item" />
<!--        <select v-model="projectFormData.assigned_to" class="vs-inputx vs-input&#45;&#45;input normal md:mb-0 hide-selected-item">-->
<!--          <option value="">{{ $t('assigned_to') }}</option>-->
<!--          <option v-for="(option, key) in userOptions" :key="'assigned_to_' + key" :value="option.value">{{ option.label }}</option>-->
<!--        </select>-->
        <validation-error :model-error="projectFormErrors.assigned_to"></validation-error>
      </div>

      <div class="mb-3">
        <tagify :label="$tc('link', 2)" v-model="projectFormData.links"></tagify>
        <validation-error :model-error="projectFormErrors.links"></validation-error>
      </div>
    </div>

  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import Tagify from '@/components/form-inputs/Tagify'
import Project from '@/models/Project'

export default {
  name: 'Shared.Projects.Edit',
  data () {
    return {
      projectFormData: {
        name: '',
        progress_status_id: '',
        assigned_to: [],
        links: []
      },
      projectFormErrors: []
    }
  },
  components: {
    Tagify
  },
  props: {
    progressStatusOptions: {
      required: true,
      type: [Object, Array]
    },
    userOptions: {
      required: true,
      type: [Object, Array]
    }
  },
  mounted () {
    EventBus.$on('initProjectFormData', this.initProjectFormData)
    EventBus.$on('initEditProject', this.initEditProject)
    EventBus.$on('initUpdateProject', this.initUpdateProject)
  },
  methods: {
    initProjectFormData () {
      this.projectFormData = {
        name: '',
        progress_status_id: '',
        assigned_to: [],
        links: []
      }
      this.projectFormErrors = {}
    },
    async initEditProject (data) {
      this.$vs.loading({container: '#EditProjectFormContainer'})
      try {
        const response = await Project.view({ id: data.id })
        this.projectFormData = response.data.project
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
      this.$vs.loading.close('#EditProjectFormContainer > .con-vs-loading')
    },
    async initUpdateProject () {

      this.$vs.loading({background: 'primary', color: '#fff', container: '#editProjectButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          const response = await Project.update(this.projectFormData)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.initProjectFormData()
          this.$emit('editProjectSuccess')
        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.projectFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#editProjectButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
  #editProjectButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
